import { getWordpressPostList } from "@src/functions/wordpress";
import WordpressPostList from "../common/components/WordpressPostList";

export async function getServerSideProps() {
  const postJson = await getWordpressPostList("1372");
  return {
    props: { data: postJson },
  }
}

function Business ({ data }: any) {
  return (
    <WordpressPostList
      group="business"
      titleName="Business Solutions"
      listTitle="Business Solutions"
      data={data}
    />
  );
};

export default Business;